import type { AlertVariant } from "./types";

export function getAlertColor(variant: keyof AlertVariant) {
  const colorMap: AlertVariant = {
    error: "red",
    info: "blue",
    success: "green",
    warning: "yellow",
  };

  return colorMap[variant];
}
